import type {
  CognitoAccessTokenPayload,
  CognitoIdTokenPayload,
} from 'aws-jwt-verify/jwt-model';
import { cognitoVerifier, cognitoVerifierSic } from './cognito-verifier';

type CognitoPayload = CognitoIdTokenPayload | CognitoAccessTokenPayload;

/**
 * Verifica si un token es de Cognito
 * @param token
 * @returns true si es de Cognito, false en caso contrario
 */
export async function verifyCognitoJwt(
  token: string,
  cognitoSourceToken: string,
): Promise<{ payload: CognitoPayload | null; isValid: boolean }> {
  try {
    const verifier =
      cognitoSourceToken === 'cognito-sic'
        ? cognitoVerifierSic
        : cognitoVerifier;

    const payload = await verifier.verify(token);

    return { payload, isValid: true };
  } catch (ex: any) {
    console.error('❌ Error verifying JWT:', {
      cognitoSourceToken,
      error: 'message' in ex ? ex.message : ex,
      usingVerifier:
        cognitoSourceToken === 'cognito-sic'
          ? 'SIC_VERIFIER'
          : 'INSPECTOR_VERIFIER',
    });

    return { payload: null, isValid: false };
  }
}
